<template>
  <div class="Modal_inner">
    <div class="LogRecord__modal">
      <div class="LogRecord__modal--pt">
        <p class="LogRecord__modal_thanks_tx">
          今日もMELONに来てくださって、<br class="_dsp-none--pc">ありがとうございます。<br>
          あなたの毎日が幸せでありますように。
        </p>
        <div class="LogRecord__modal_thanks_label_area">
          <div class="LogRecord__modal_thanks_label">
            <p>{{ popupReward.title }}<br class="_dsp-none--pc">{{ popupReward.sub_title }}</p>
          </div>
          <div class="LogRecord__modal_note _ft-rgt">
            今日のマインドフルネス
          </div>
        </div>
      </div>
    </div>
    <div class="LogRecord__modal_btn_area" @click="finishUpdate">
      <div class="LogRecord__modal_btn LogRecord__modal_btn--check ft_en _hover_pt01 _cross" />
    </div>
  </div>
</template>

<script>
import keyVisualService from '@/services/keyVisualService'

export default {
  name: 'LogWriteModalStep3',
  data() {
    return {
      popupReward: {
        title: '',
        sub_title: ''
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    finishUpdate() {
      this.$emit('modalClose', 'updated')
    },
    async init() {
      const response = await keyVisualService.popupReward()
      this.popupReward.title = response.data.title
      this.popupReward.sub_title = response.data.sub_title
    }
  }
}
</script>
